import React, { useEffect, useRef, useState } from 'react';
import angle from '../../images/login-register/down-angle.png';
import { jwtDecode } from 'jwt-decode';
import styles from './NavbarLogout.module.css'; // Import the CSS module

const NavbarLogout = ({ UserName, prefix }) =>
{
    const [isOpen, setIsOpen] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const dropdownRef = useRef(null);

    const toggleDropdown = () =>
    {
        setIsOpen(!isOpen);
    };

    const handleButtonClick = (action) =>
    {
        if (action === 'logout')
        {
            localStorage.removeItem('token');
            sessionStorage.removeItem('loginSuccessMessage');
            sessionStorage.removeItem('showToast');
            sessionStorage.removeItem('showBusinessToast');
            sessionStorage.removeItem('userImage');
            localStorage.removeItem('businesName');
            window.location.href = prefix = '/login';
        }
    };

    const handleClickOutside = (event) =>
    {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target))
        {
            setIsOpen(false);
        }
    };

    useEffect(() =>
    {
        document.addEventListener('mousedown', handleClickOutside);
        var image = sessionStorage.getItem('userImage');
        if (image !== "null")
            setProfileImage(image);
        return () =>
        {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleMyProfileClick = () =>
    {
        const userType = jwtDecode(localStorage.getItem('token')).UserType;
        if (userType === 'Business')
            window.location.href = '/businessProfile';
        else
            window.location.href = '/homeUserProfile';
    }

    return (
        <div className={styles.headerBtnsWrapper} ref={dropdownRef}> {/* Applied .headerBtnsWrapper for d-flex and gap */}
            <div className={`${styles.userDropdown} ${styles.userAfterLogout}`}>
                <button onClick={toggleDropdown} className={styles.dropdownButton}>
                    <span className={styles.userIcon}>
                        {profileImage ? (
                            <img src={profileImage} alt={UserName || 'User profile'} />
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                id="Outline"
                                viewBox="0 0 24 24"
                                // width="20" // Handled by CSS module
                                // height="20" // Handled by CSS module
                                // fill="#ffffff" // Handled by CSS module
                            >
                                <path d="M12,12A6,6,0,1,0,6,6,6.006,6.006,0,0,0,12,12ZM12,2A4,4,0,1,1,8,6,4,4,0,0,1,12,2Z" />
                                <path d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z" />
                            </svg>
                        )}
                    </span>
                    <span className={styles.userName} title={UserName}>{UserName}</span>
                    <img src={angle} className={styles.dropdownArrow} alt="Dropdown Arrow" />
                </button>
                {isOpen && (
                    <ul className={styles.dropdownMenu}>
                        <li>
                            {/* Using <a> tags for now, consider <button> or <Link> from react-router-dom for better semantics/SPA behavior */}
                            <a onClick={handleMyProfileClick} className={styles.dropdownItem} role="menuitem" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleMyProfileClick();}}>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" /* width="20" height="20" */ >
                                    <path d="M12,12A6,6,0,1,0,6,6,6.006,6.006,0,0,0,12,12ZM12,2A4,4,0,1,1,8,6,4,4,0,0,1,12,2Z" />
                                    <path d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z" /></svg>
                                My Profile
                            </a>
                            <a onClick={() => handleButtonClick('logout')} className={styles.dropdownItem} role="menuitem" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleButtonClick('logout');}}>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Outline" viewBox="0 0 24 24" /* width="20" height="20" */ >
                                    <path d="M22.829,9.172,18.95,5.293a1,1,0,0,0-1.414,1.414l3.879,3.879a2.057,2.057,0,0,1,.3.39c-.015,0-.027-.008-.042-.008h0L5.989,11a1,1,0,0,0,0,2h0l15.678-.032c.028,0,.051-.014.078-.016a2,2,0,0,1-.334.462l-3.879,3.879a1,1,0,1,0,1.414,1.414l3.879-3.879a4,4,0,0,0,0-5.656Z"></path>
                                    <path d="M7,22H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2H7A1,1,0,0,0,7,0H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H7a1,1,0,0,0,0-2Z"></path>
                                </svg> Logout
                            </a>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
};

export default NavbarLogout;
